import SplitTicketType from '@trainline-shareable/journey-live-tracker/lib/types/SplitTicketType';
import { PassengerType as PassengerTypeExtra } from '@trainline-shareable/journey-live-tracker/lib/types/LegExtras';
import PassengerType from '@trainline-shareable/journey-live-tracker/lib/types/PassengerType';
import { SeatClass } from '@trainline-shareable/journey-live-tracker/lib/types/SeatReservation';
import { LocalAreaTransportTypeValues } from '@trainline-shareable/journey-live-tracker/lib/types/LocalAreaTransportAddons';
import { LegTransportType } from '@trainline-shareable/journey-live-tracker';

const splitSave = {
  type: 'DirectSplit' as SplitTicketType,
  requiresSeatChange: true,
  stationToChange: 'Stockport',
};

const bikeReservations = [
  {
    compartment: {},
    seatingOptions: '',
  },
  {
    compartment: {},
    seatingOptions: '',
  },
];

const extras = [
  {
    passenger: {
      id: '70795e9d-b852-44ce-a2b1-543eccdfcc7g',
      firstName: 'John',
      lastName: 'Snow',
      type: 'senior' as PassengerTypeExtra,
    },
    paidExtras: ['Extra luggage', 'Pet traveller added'],
  },
  {
    passenger: {
      id: '70795e9d-b852-44ce-a2b1-543eccdfcc7f',
      firstName: 'Bruce',
      lastName: 'Wayne',
      type: 'senior' as PassengerTypeExtra,
    },
    paidExtras: ['Extra luggage', 'Pet traveller added', 'Bike compartment'],
  },
  {
    paidExtras: ['Extra luggage', 'Pet traveller added'],
  },
];

const seatReservations = [
  {
    seatNumber: '17',
    comfortClass: 'Seat',
    seatingOptions: ' Aisle',
    compartment: {
      identifier: 'B',
    },
    seatClass: SeatClass.STANDARD,
    passengerType: PassengerType.Adult,
    originStation: 'London Euston',
    destinationStation: 'Stockport',
  },
  {
    seatNumber: '18',
    comfortClass: 'Seat',
    seatingOptions: ' Window',
    compartment: {
      identifier: 'B',
    },
    seatClass: SeatClass.STANDARD,
    passengerType: PassengerType.Adult,
    originStation: 'London Euston',
    destinationStation: 'Stockport',
  },
  {
    seatNumber: '34',
    comfortClass: 'Seat',
    seatingOptions: ' Aisle',
    compartment: {
      identifier: 'B',
    },
    seatClass: SeatClass.STANDARD,
    passengerType: PassengerType.Adult,
    originStation: 'Stockport',
    destinationStation: 'Manchester Piccadilly',
  },
  {
    seatNumber: '35',
    comfortClass: 'Seat',
    seatingOptions: ' Window',
    compartment: {
      identifier: 'B',
    },
    seatClass: SeatClass.STANDARD,
    passengerType: PassengerType.Adult,
    originStation: 'Stockport',
    destinationStation: 'Manchester Piccadilly',
  },
];

const localAreaTransportAddons = {
  origin: [
    {
      type: LocalAreaTransportTypeValues.LONDONTRAVELCARD,
      label: 'London Travelcard Zones 1-4',
    },
  ],
  destination: [
    {
      type: LocalAreaTransportTypeValues.PLUSBUS,
      label: 'Manchester+Bus',
    },
  ],
};

const journey = {
  id: '47246373',
  direction: 'Outward',
  origin: 'Hayes & Harlington',
  destination: 'Manchester Piccadilly',
  duration: '',
  departAt: '',
  arriveAt: '',
  legs: [
    {
      id: '4724637357357347', // provide the leg id from the itinerary data
      localArriveAt: '2025-06-04T16:38:00+01:00',
      localDepartAt: '2025-06-04T16:12:00+01:00',
      origin: {
        id: 'f42e07d7-4af5-45db-ab3f-26e1bf2b7126',
        code: 'urn:trainline:atoc:loc:HAY3186',
        name: 'Hayes & Harlington',
      },
      destination: {
        id: '28e7425d-221a-4983-a2a1-10c9d1d9a645',
        code: 'urn:trainline:atoc:loc:TCR6556',
        name: 'Tottenham Court Road (Elizabeth line)',
      },
      carrierName: 'Elizabeth line',
      carrierUrn: 'urn:trainline:atoc:carrier:XR',
      timetableId: 'P07170',
      transportModeName: 'train' as LegTransportType,
      legNumber: 1,
      action: {
        label: 'Other valid trains',
        function: () => true,
      },
      bikeReservations,
      extras,
      seatReservations,
      totalLegs: 3,
      localAreaTransportAddons,
      onboardServices: ['Bike compartment', 'Wifi', 'Cocktail lounge', 'Jazz Band', 'IMAX screen'],
    },
    {
      id: 'dcab0e6f-c6c0-4071-90f6-43a181dd6e52',
      localArriveAt: '2025-06-04T17:12:00+01:00',
      localDepartAt: '2025-06-04T16:38:00+01:00',
      origin: {
        id: '28e7425d-221a-4983-a2a1-10c9d1d9a645',
        code: 'urn:trainline:atoc:loc:TCR6556',
        name: 'Tottenham Court Road (Elizabeth line)',
        longitude: -0.1346,
        latitude: 51.5284,
        countryCode: 'GB',
      },
      destination: {
        id: 'bdc62f0d-1755-4364-b7bc-58e6757bbe11',
        code: 'urn:trainline:atoc:loc:EUS1444',
        name: 'London Euston',
        longitude: -0.1445,
        latitude: 51.4953,
        countryCode: 'GB',
      },
      disruptions: [],
      carrierName: 'Unknown Operator',
      carrierUrn: 'urn:trainline:atoc:carrier:**',
      timetableId: null,
      transportModeName: 'rapidTransit' as LegTransportType,
      legNumber: 2,
      totalLegs: 3,
    },
    {
      id: '124125125125142515',
      localArriveAt: '2025-06-04T19:19:00+01:00',
      localDepartAt: '2025-06-04T17:12:00+01:00',
      origin: {
        id: 'bdc62f0d-1755-4364-b7bc-58e6757bbe11',
        code: 'urn:trainline:atoc:loc:EUS1444',
        name: 'London Euston',
      },
      destination: {
        id: '527dc5d5-97ad-477c-ab92-dfcee77a8c1a',
        code: 'urn:trainline:atoc:loc:MAN2968',
        name: 'Manchester Piccadilly',
      },
      carrierName: 'Avanti West Coast',
      carrierUrn: 'urn:trainline:atoc:carrier:VT',
      timetableId: 'W09686',
      transportModeName: 'train' as LegTransportType,
      legNumber: 3,
      splitSave,
      pnrReference: 'V56XNZ',
      bikeReservations,
      extras,
      seatReservations,
      totalLegs: 3,
      localAreaTransportAddons,
      onboardServices: ['Bike compartment', 'Wifi', 'Cocktail lounge', 'Jazz Band', 'IMAX screen'],
    },
  ],
};

// Just for testing
export const inboundJourney = {
  ...journey,
  direction: 'Inward',
  legs: [...journey.legs].reverse(),
};

export default journey;
